module.exports = __webpack_public_path__ + "static/img/img_form_1@2x_zh.06bafab9.png";